<template>
  <v-col id="privacy" class="privacy-text">
    <p>Stand: 26. Juli 2026</p>

    <h2>1. Verantwortlicher</h2>
    <p>
      {{ company.name }}<br>
      {{ company.address1 }}<br>
      {{ company.address2 }}<br>
      Telefon: {{ company.phone }}<br>
      E-Mail: <a :href="`mailto:${company.mailFrom}`">{{ company.mailFrom }}</a>
    </p>

    <h2>2. Allgemeine Hinweise</h2>
    <p>
      Wir betreiben eine Plattform, über die Kunden Dienstleister suchen, Preise berechnen lassen
      und Anfragen an ausgewählte Unternehmen senden können. Außerdem können Unternehmen ein
      öffentliches Unternehmensprofil anlegen und verwalten. Wir verarbeiten personenbezogene Daten
      nur, soweit dies für den Betrieb der Plattform, die gewünschte Funktion, die Bearbeitung von
      Anfragen, die Verwaltung von Konten, die Sicherheit der Website oder aufgrund gesetzlicher
      Pflichten erforderlich ist.
    </p>
    <p>
      Rechtsgrundlagen sind insbesondere Art. 6 Abs. 1 lit. a DSGVO bei Einwilligungen,
      Art. 6 Abs. 1 lit. b DSGVO bei der Nutzung unserer Plattform, vorvertraglichen Maßnahmen
      und Anfrageübermittlung, Art. 6 Abs. 1 lit. c DSGVO bei gesetzlichen Pflichten sowie
      Art. 6 Abs. 1 lit. f DSGVO bei berechtigten Interessen wie Sicherheit, Missbrauchsschutz
      und technischer Stabilität.
    </p>

    <h2>3. Hosting und Server-Protokolle</h2>
    <p>
      Die Anwendung wird auf Servern der Hetzner Online GmbH, Industriestr. 25, 91710 Gunzenhausen,
      betrieben. Beim Aufruf der Website können technisch erforderliche Protokolldaten verarbeitet
      werden, insbesondere IP-Adresse, Datum und Uhrzeit, aufgerufene Ressource, Referrer,
      Browsertyp und Betriebssystem. Die Verarbeitung dient der sicheren, stabilen und fehlerfreien
      Bereitstellung der Website auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
    </p>

    <h2>4. Kundenkonto, Registrierung und Anmeldung</h2>
    <p>
      Wenn Sie ein Kundenkonto erstellen oder sich anmelden, verarbeiten wir die von Ihnen
      eingegebenen Daten, insbesondere Kundentyp, Anrede, Name, Firmenname bei gewerblichen Kunden,
      Adresse, Telefonnummer, E-Mail-Adresse, Passwort in verschlüsselter Form, Verifizierungsstatus
      und technische Anmeldedaten. Zweck ist die Erstellung und Verwaltung Ihres Kontos, die
      Anmeldung, die Vorbefüllung Ihrer Anfrageangaben und die Zuordnung gesendeter Anfragen.
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.
    </p>

    <h2>5. Unternehmenskonto und Unternehmensprofil</h2>
    <p>
      Wenn sich ein Unternehmen auf unserer Website eintragen lässt, verarbeiten wir die für die
      Registrierung und Profilverwaltung erforderlichen Daten. Dazu gehören insbesondere
      Unternehmensname, Rechtsform, vertretungsberechtigte oder ansprechbare Person, Funktion im
      Unternehmen, Telefonnummer, E-Mail-Adresse, Anschrift, Unternehmensbeschreibung, Logo,
      Titelbild, Bildergalerie, Branche, angebotene Kategorien, Stundenpreise, Mindestpreis,
      Fahrtkosten, Einzugsgebiet, Öffnungszeiten, Anfragezeiten, Umsatzsteuerangaben und
      Veröffentlichungsstatus.
    </p>
    <p>
      Zweck ist die Erstellung, Prüfung, Verwaltung und Veröffentlichung des Unternehmensprofils
      sowie die Vermittlung und Weiterleitung von Kundenanfragen. Rechtsgrundlage ist Art. 6 Abs. 1
      lit. b DSGVO. Öffentlich sichtbar sind nur die Angaben, die für das Unternehmensprofil und die
      Kontaktaufnahme bestimmt sind, zum Beispiel Unternehmensname, Beschreibung, Logo, Bilder,
      Branche, Leistungen, Öffnungszeiten, Kontaktmöglichkeiten und Bewertungen.
    </p>

    <h2>6. Preisrechner und Kundenanfragen</h2>
    <p>
      Wenn Sie den Preisrechner nutzen oder eine Anfrage senden, verarbeiten wir alle Angaben, die
      für die Berechnung und Übermittlung der Anfrage erforderlich sind. Dazu gehören insbesondere
      Ihre Adresse, Koordinaten der ausgewählten Adresse, Branche, Kategorien, Leistungen, Mengen,
      Art des Auftrags, Wunschtermin, ausgewähltes Unternehmen, berechnete Preisbestandteile,
      Fahrtstrecke, Kontaktdaten aus Ihrem Kundenkonto und technische Übermittlungsdaten.
    </p>
    <p>
      Die Anfrage wird über unsere Plattform gespeichert und an das von Ihnen ausgewählte Unternehmen
      übermittelt. Das Unternehmen erhält die Daten, die es benötigt, um Ihre Anfrage zu prüfen,
      Sie zu kontaktieren, den Wunschtermin abzustimmen, ein Angebot zu bestätigen oder den Auftrag
      weiter zu bearbeiten. Außerdem erhalten Sie eine Bestätigung Ihrer Anfrage per E-Mail.
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.
    </p>
    <p>
      Nach der Übermittlung verarbeitet das ausgewählte Unternehmen die erhaltenen Daten zusätzlich
      in eigener Verantwortung. Bitte beachten Sie daher auch die Datenschutzerklärung des jeweiligen
      Unternehmens auf dessen Unternehmensseite.
    </p>

    <h2>7. E-Mail-Kommunikation und Verifizierung</h2>
    <p>
      Wir verarbeiten E-Mail-Adressen und Nachrichteninhalte für Registrierung, E-Mail-Bestätigung,
      Passwortzurücksetzung, Änderung von E-Mail-Adressen, Anfragebestätigungen und die
      Kommunikation zwischen Kunden und Unternehmen. Dabei können der eingesetzte E-Mail-Dienstleister
      und die E-Mail-Anbieter der Empfänger technische Verbindungsdaten und Inhaltsdaten erhalten.
      Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO sowie bei Sicherheitsnachrichten
      Art. 6 Abs. 1 lit. f DSGVO.
    </p>

    <h2>8. Adressvorschläge mit Photon</h2>
    <p>
      Für Adressvorschläge verwenden wir die Photon-Schnittstelle unter photon.komoot.io, die von
      der komoot GmbH bereitgestellt wird. Sobald Sie mindestens drei Zeichen in ein Adressfeld
      eingeben, wird der eingegebene Suchtext zusammen mit technisch erforderlichen Verbindungsdaten,
      insbesondere Ihrer IP-Adresse, an Photon übertragen. Zweck ist die Suche und eindeutige Auswahl
      einer vollständigen Adresse. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die
      Adresssuche zur gewünschten Preisberechnung oder Anfrage erforderlich ist, ansonsten
      Art. 6 Abs. 1 lit. f DSGVO.
    </p>

    <h2>9. Fahrstreckenberechnung mit OSRM</h2>
    <p>
      Zur Prüfung des Einzugsgebiets und zur Berechnung von Fahrtkosten übermittelt unser Server die
      Koordinaten der ausgewählten Kundenadresse und der Unternehmensadresse an die OSRM-Schnittstelle.
      Es werden keine Namen, E-Mail-Adressen oder Telefonnummern an OSRM übertragen. Zweck ist die
      Ermittlung der Fahrstrecke. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, hilfsweise
      Art. 6 Abs. 1 lit. f DSGVO.
    </p>

    <h2>10. Bewertungen</h2>
    <p>
      Angemeldete Kunden können Unternehmen bewerten, wenn sie eine Anfrage gesendet haben. Wir
      verarbeiten dabei Sternebewertung, optionalen Bewertungstext, Zeitpunkt, Zuordnung zum
      Unternehmen und zum Kundenkonto sowie gegebenenfalls eine öffentliche Antwort des Unternehmens.
      Öffentlich angezeigt werden nur eingeschränkte Kundendaten, zum Beispiel Anrede und ein
      abgekürzter Nachname. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO im Rahmen der
      Plattformnutzung sowie Art. 6 Abs. 1 lit. f DSGVO zur Qualitätssicherung und Information
      anderer Nutzer.
    </p>

    <h2>11. Cookies und lokaler Speicher</h2>
    <p>
      Wir verwenden technisch notwendige Speicherzugriffe für Anmeldung, Sicherheit und die Speicherung
      Ihrer Datenschutzentscheidung. Ein Anmelde-Token kann im lokalen Speicher Ihres Browsers abgelegt
      werden, damit Sie angemeldet bleiben. Soweit eine serverseitige Sitzung benötigt wird, kann ein
      technisch notwendiges Session-Cookie gesetzt werden.
    </p>
    <p>
      Nur mit Ihrer Einwilligung speichern wir Komfortdaten über den aktuellen Nutzungsvorgang hinaus.
      Rechtsgrundlage ist § 25 Abs. 1 TDDDG in Verbindung mit Art. 6 Abs. 1 lit. a DSGVO. Die
      Einwilligung können Sie jederzeit über „Datenschutz-Einstellungen“ widerrufen.
    </p>

    <h2>12. Lokale Schriftarten und Symbole</h2>
    <p>
      Roboto, Material Design Icons und Font Awesome werden lokal von unserem Server ausgeliefert.
      Beim Laden dieser Ressourcen wird keine Verbindung zu Google, Fonticons oder einem externen CDN
      hergestellt.
    </p>

    <h2>13. Empfänger personenbezogener Daten</h2>
    <p>
      Empfänger personenbezogener Daten können insbesondere Hostinganbieter, technische Dienstleister,
      E-Mail-Dienstleister, das von Ihnen ausgewählte Unternehmen, Photon/komoot für Adressvorschläge
      und OSRM für Fahrstreckenberechnung sein. Soweit Dienstleister Daten in unserem Auftrag
      verarbeiten, werden erforderliche Verträge nach Art. 28 DSGVO abgeschlossen.
    </p>

    <h2>14. Speicherdauer</h2>
    <p>
      Soweit in dieser Erklärung keine besondere Dauer genannt ist, speichern wir Daten nur so lange,
      wie der jeweilige Zweck besteht. Danach werden sie gelöscht oder anonymisiert, sofern keine
      gesetzlichen Aufbewahrungspflichten, Verjährungsfristen oder berechtigten Nachweis- und
      Sicherheitsinteressen eine weitere Speicherung erfordern.
    </p>

    <h2>15. Ihre Rechte</h2>
    <p>
      Sie haben nach Maßgabe der DSGVO das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung
      der Verarbeitung, Datenübertragbarkeit und Widerspruch. Eine erteilte Einwilligung können Sie
      jederzeit mit Wirkung für die Zukunft widerrufen. Außerdem können Sie sich bei einer
      Datenschutzaufsichtsbehörde beschweren.
    </p>

    <h2>16. Sicherheit</h2>
    <p>
      Die Übertragung erfolgt verschlüsselt über TLS. Wir treffen angemessene technische und
      organisatorische Maßnahmen, um personenbezogene Daten vor Verlust, Missbrauch und unbefugtem
      Zugriff zu schützen.
    </p>
  </v-col>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'LegalPrivacy',
  computed: {
    ...mapGetters(['company'])
  }
}
</script>
